// Components/Tabs/DeveloperToolsTab.jsx

import React from "react";
import PropTypes from "prop-types";
import Slider from "../Slider/Slider";
import { SliderBranch } from "../SliderBranch/SliderBranch.jsx";
import EmailDebugTab from "./EmailDebugTab.jsx";
import { MailIcon } from "../AdminIcon";

/**
 * DeveloperToolsTab Component
 *
 * Hub for operational-diagnostics tools that don't fit under regular admin
 * tasks (e.g. email debugging). Super-admin only. Nested under Admin tools
 * so it has room to grow without cluttering that top-level menu.
 *
 * @param {Object} props - Component properties.
 * @param {Object} props.user - The current user object containing user details.
 * @param {Function} props.pushTab - Function to push a new tab onto the stack.
 * @param {Function} props.revert - Function to revert the tab stack by a specified number of steps.
 */
function DeveloperToolsTab({ user, pushTab, revert }) {
  const entries = [
    {
      icon: MailIcon,
      text: "Email debugging",
      description: "Check email configuration and reminder scheduling, and send yourself a test email.",
      onClick: () => pushTab(
        <EmailDebugTab adminRoute="email"
          key="emailDebug"
          user={user}
          pushTab={pushTab}
          revert={revert}
        />
      ),
      disabled: user.isSuperAdmin ? false : true
    }
  ];

  return (
    <Slider
      name="Developer tools"
      navColor="rgb(220, 53, 69)"
      slide={true}
      index={0}
      onClick={() => revert(1)}
    >
      <SliderBranch entries={entries} />
    </Slider>
  );
}

DeveloperToolsTab.propTypes = {
  user: PropTypes.object.isRequired,
  pushTab: PropTypes.func.isRequired,
  revert: PropTypes.func.isRequired,
};

export default DeveloperToolsTab;
